// Note: Commented out for ticket BP-4410
// See below for more info
import { isHRB } from 'shared-components/src/utils/whitelabel';
import { HRB_KNOWLEDGE_BASE_LINK, DEFAULT_KNOWLEDGE_BASE_LINK } from 'shared-components/src/utils/externalLink';

// Function to determine the appropriate knowledge base link based on client type
const getAboutMyCardLink = () => isHRB() ? HRB_KNOWLEDGE_BASE_LINK : DEFAULT_KNOWLEDGE_BASE_LINK;

export default [
  {
    to: '/',
    for: 'dashboard'
  },
  {
    to: '/transfers',
    for: 'transfers'
  },
  {
    to: '/profile',
    for: 'profile'
  },
  {
    externalLink: getAboutMyCardLink(),
    for: 'about'
  },
  // Commented out while knowledge base page is updating for U.S clients
  // See ticket BP-4410
  // {
  //   externalLink: KNOWLEDGE_PORTAL_LINK,
  //   for: 'knowledge-base'
  // }
];
